import { gql } from '@apollo/client';

export const ADD_PEOPLE_TO_COHORT = gql`
  mutation AddPeopleToCohort($input: AddPeopleToCohortInput!) {
    cohort: addPeopleToCohort(input: $input) {
      id
    }
  }
`;
